export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Betalningsvillkor";
};

export const detailUrl = ({ id }) => {
  return `/rental-notifications/settings/debt-setting/${id}`;
};
